<style scoped lang="scss">
textarea {
  min-height: 35rem;
}
.nav-pills .nav-item .nav-link.active {
  background-color: #007bff;
  border-radius: 0.25rem !important;
}
.nav-pills .nav-item .nav-link {
  border: 0px solid #007bff;
}
.nav.nav-pills {
  margin-bottom: 10px;
}
pre span.code {
  color: red;
  background: #ff000021;
  border: 1px solid red;
  border-spacing: 5px;
  padding: 3px 3px 1px 3px;
}
</style>

<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Stammdaten</h4>
      </div>
      <div class="card-body">
        <ul class="nav nav-pills" id="myTab" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-toggle="tab"
              href="#impressum"
              role="tab"
              >Impressum</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#datenschutz" role="tab"
              >Datenschutz</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#agb" role="tab">AGB</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#medienrichtlinien"
              role="tab"
              >Medienrichtlinien</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="impressum" role="tabpanel">
            <div class="form-group">
              <textarea class="form-control" v-model="data.impressumPage" />
            </div>
          </div>
          <div class="tab-pane fade" id="datenschutz" role="tabpanel">
            <div class="form-group">
              <textarea class="form-control" v-model="data.privatePolicyPage" />
            </div>
          </div>
          <div class="tab-pane fade" id="agb" role="tabpanel">
            <div class="form-group">
              <textarea class="form-control" v-model="data.agbPage" />
            </div>
          </div>
          <div class="tab-pane fade" id="medienrichtlinien" role="tabpanel">
            <div class="form-group">
              <textarea class="form-control" v-model="data.mediaPolicyPage" />
            </div>
          </div>
          <div class="form-group">
            <button @click="persist()" class="btn btn-primary">
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import "bootstrap";
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      this.data = this.$store.getters["setting/all"];
    });
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        impressumPage: "",
        privatePolicyPage: "",
        agbPage: "",
        mediaPolicyPage: ""
      }
    };
  }
};
</script>
